// FUNCTIONS
async function ajaxAuditionSignup(appointment, discipline, talent) {
	try {
		const formData = new FormData();

		formData.append('action', 'ajaxAuditionSignup');
		formData.append('appointment', appointment);
		formData.append('discipline', discipline);
		formData.append('talent', talent);

		const response = await fetch(adminAjax, {
			body: formData,
			method: 'POST'
		});

		if (!response.ok) {
			throw new Error('Failed to submit audition.');
		} else {
			const message = await response.json();

			console.log(message, message.data);

			if (message.data == 'failed') {
				alert('Cannot connect to the server. Please try again later.');
			} else if (message.data == 'filled') {
				alert('All slots for this audition are currently filled.');
			} else {
				document.querySelector('.audition .confirmation .datetime span').textContent = message.data;

				document.querySelector('.audition .form .appointment').style.display = 'none';
				document.querySelector('.audition .form .confirmation').style.display = '';

				document.querySelector('.audition .form .steps .active').classList.remove('active');
				document.querySelector('.audition .form .steps span:last-of-type').classList.add('active');

				document.querySelector('.audition .form .actions .back').style.display = 'none';
				document.querySelector('.audition .form .actions .next').style.display = 'none';
			}
		}
	} catch (error) {
		console.error(error);
		alert('Cannot connect to the server. Please try again later.');
	}
}

async function ajaxAuditionSubmission(city, date, title) {
	try {
		const formData = new FormData();

		formData.append('action', 'ajaxAuditionSubmission');
		formData.append('city', city);
		formData.append('date', date);
		formData.append('title', title);

		const response = await fetch(adminAjax, {
			body: formData,
			method: 'POST'
		});

		if (!response.ok) {
			throw new Error('Failed to submit audition.');
		} else {
			const message = await response.json();
			alert('Your submission has been successfully submitted.');
		}
	} catch (error) {
		console.error(error);
		alert('Cannot connect to the server. Please try again later.');
	}
}

const renderAuditionInitial = () => {
	appointmentSelect = document.querySelector('.audition .form .appointment select')?.innerHTML;
};

// VARIABLES
let appointmentSelect;

// INITIALIZATION
renderAuditionInitial();

// EVENT LISTENERS
document.querySelector('.audition .form .actions .back')?.addEventListener('click', () => {
	document.querySelector('.audition .form .appointment').style.display = 'none';
	document.querySelector('.audition .form .talent').style.display = '';

	document.querySelector('.audition .form .appointment select').remove();
	document.querySelector('.audition .form .appointment').insertAdjacentHTML('beforeend', '<select>' + appointmentSelect + '</select>');

	document.querySelector('.audition .form .steps .active').classList.remove('active');
	document.querySelector('.audition .form .steps span:first-of-type').classList.add('active');

	document.querySelector('.audition .form .actions .back').style.display = 'none';
});

document.querySelector('.audition .form .actions .next')?.addEventListener('click', () => {
	const appointmentForm = document.querySelector('.audition .form .appointment');
	const talentForm = document.querySelector('.audition .form .talent');

	if (appointmentForm.offsetWidth > 0 || appointmentForm.offsetHeight > 0) {
		const appointment = document.querySelector('.audition .form .appointment select');
		const talent = document.querySelector('.audition .form .talent select');

		let discipline;

		if (location.pathname.indexOf('headliner') != -1) {
			discipline = 'Headliner';
		} else if (location.pathname.indexOf('livemusic') != -1) {
			discipline = 'Live Music';
		} else if (location.pathname.indexOf('productions') != -1) {
			discipline = 'Productions';
		}

		if (!appointment.options[appointment.selectedIndex].disabled) {
			ajaxAuditionSignup(appointment.value, discipline, talent.value);
		} else {
			alert('Please select a appointment.');
		}
	} else if (talentForm.offsetWidth > 0 || talentForm.offsetHeight > 0) {
		const talent = document.querySelector('.audition .form .talent select');

		if (!talent.options[talent.selectedIndex].disabled) {
			document.querySelectorAll('.audition .form .appointment optgroup option:not([data-talent="' + talent.value + '"])').forEach(option => option.remove());

			document.querySelector('.audition .form .talent').style.display = 'none';
			document.querySelector('.audition .form .appointment').style.display = '';

			document.querySelector('.audition .form .steps .active').classList.remove('active');
			document.querySelector('.audition .form .steps span:nth-of-type(2)').classList.add('active');

			document.querySelector('.audition .form .actions .back').style.display = '';
		} else {
			alert('Please select a talent.');
		}
	}
});

document.querySelector('.submit-profile')?.addEventListener('click', () => {
	const city = event.currentTarget.dataset.auditionCity;
	const date = event.currentTarget.dataset.auditionDate;
	const title = event.currentTarget.dataset.auditionTitle;

	ajaxAuditionSubmission(city, date, title);
});